export const resolve = (path: string, obj: any = {}, separator = '.') => {
  const properties = Array.isArray(path) ? path : path.split(separator);
  return (properties as string[]).reduce(
    (prev: string, curr: string) => prev?.[curr as any],
    obj
  );
};
